import { Github } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export function GitHubConnectWidget() {
  function handleConnect() {
    window.open(api.github.oauthUrl(), "_blank");
  }

  return (
    <Card variant="default" padding="none" className="overflow-hidden max-w-md animate-slide-up">
      <div className="flex items-center gap-3 px-4 py-3">
        <div className="flex items-center justify-center h-8 w-8 rounded-lg bg-intri-accent-ghost">
          <Github size={16} className="text-intri-accent" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-intri-text">Connect GitHub</p>
          <p className="text-2xs text-intri-muted mt-0.5">
            Link your repositories to start building
          </p>
        </div>
      </div>
      <div className="flex gap-2 px-4 py-3 border-t border-intri-border">
        <Button variant="default" size="sm" onClick={handleConnect}>
          Connect GitHub
        </Button>
      </div>
    </Card>
  );
}
